import {
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
  Typography,
  Radio,
  Space,
  Checkbox,
  Modal,
} from "antd";
import { UploadOutlined, RobotOutlined, PlusOutlined } from "@ant-design/icons";

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadProduct } from "../../redux/actions/product/getAllProductAction";
import { addPurchase } from "../../redux/actions/purchase/addPurchaseAction";
import { updatePurchase } from "../../redux/actions/purchase/editPurchaseAction";
import { loadSinglePurchase } from "../../redux/actions/purchase/detailPurchaseAction";
import { loadSuppliers } from "../../redux/actions/supplier/getSuppliersAction";
import { loadAllProductCurrency } from "../../redux/actions/productCurrency/getProductCurrencyAction";
import Products from "./Products";
import BillUpload from "./BillUpload";
import PurchaseConfirmation from "./PurchaseConfirmation";
import AddSup from "../suppliers/addSup";
import "./purchase.css";

import moment from "moment";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { loadSupplier } from "../../redux/actions/supplier/detailSupplierAction";
import { getPurchaseOrderById } from "../../redux/actions/purchase/purchaseOrderAction";
import { getSalesOrderById } from "../../redux/actions/sale/salesOrderAction";
import { loadAllBookPublisher } from "../../redux/actions/bookPublisher/getBookPublisherAction";
import AddBookPublisher from "../bookPublisher/addBookPublisher";
import axios from "axios";
import {
  confirmMasterListPriceSyncThen as confirmMasterPriceSyncThen,
  getReferenceListPriceFromProduct,
} from "../../utils/productListPriceSync";

const { Title } = Typography;

const AddPurch = () => {
  const { Option } = Select;
  const { id: editId } = useParams();
  const [formData, setFormData] = useState({});
  const [date, setDate] = useState(moment());
  const [afterDiscount, setAfterDiscount] = useState(0);
  const [loader, setLoader] = useState(false);
  const [discount, setDiscount] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();
  const isEditMode = Boolean(editId);

  const [discountType, setDiscountType] = useState("item");
  const [globalDiscountValue, setGlobalDiscountValue] = useState("");
  const [globalQuantityValue, setGlobalQuantityValue] = useState("");
  const [showBillUpload, setShowBillUpload] = useState(false);
  const [addSupplierModalVisible, setAddSupplierModalVisible] = useState(false);
  const [supplierSearchValue, setSupplierSearchValue] = useState('');
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [extractedData, setExtractedData] = useState(null);
  const [confirmationData, setConfirmationData] = useState(null);
  const [publisherModalVisible, setPublisherModalVisible] = useState(false);
  const [publisherInitialName, setPublisherInitialName] = useState("");
  const [publisherProductKey, setPublisherProductKey] = useState(null);

  // Round-off states
  const [isRoundOffEnabled, setIsRoundOffEnabled] = useState(false);
  const [roundOffAmount, setRoundOffAmount] = useState(0);

  const onClickLoading = () => {
    setLoader(true);
  };

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadSuppliers({ page: 1, limit: 10000 }));
  }, []);

  useEffect(() => {
    dispatch(loadProduct({ page: 1, limit: 10000 }));
  }, []);
  useEffect(() => {
    dispatch(loadAllProductCurrency({ page: 1, limit: 10 }));
  }, []);
  useEffect(() => {
    dispatch(loadAllBookPublisher({ page: 1, limit: 1000 }));
  }, []);

  // Load purchase invoice when in edit mode
  useEffect(() => {
    if (editId) {
      dispatch(loadSinglePurchase(editId));
    }
  }, [editId, dispatch]);

  const allSuppliers = useSelector((state) => state.suppliers.list);
  const allProducts = useSelector((state) => state.products.list);
  const allCurrency = useSelector((state) => state.productCurrencies.list);
  const allPublishers = useSelector((state) => state.bookPublishers?.list) || [];
  const purchaseDetail = useSelector((state) => state.purchases.purchase);
  const singlePurchaseInvoice = purchaseDetail?.singlePurchaseInvoice;
  const [supplier, setSupplier] = useState(null);
  const [purchaseOrderId, setPurchaseOrderId] = useState(null);
  const [salesOrderId, setSalesOrderId] = useState(null);

  // allProducts.forEach(item=>{
  // 	item.value=item.isbn +' ('+item.name +')';
  // })
  // Form Function
  const [form] = Form.useForm();
  const billDiscountFromForm = Form.useWatch("billDiscount", form);
  const [totalDiscountPaidDue, setTotalDiscountPaidDue] = useState({
    total: 0,
    fixDiscount: 0,
    fixDiscountAmt: 0,
    discount: 0,
    afterDiscount: 0,
    paid: 0,
    due: 0,
    totalQty: 0,
  });
  const [additionalDiscount, setAdditionalDiscount] = useState("");
  const [discountAmount, setDiscountAmount] = useState("");

  const runPurchaseSubmit = async (values) => {
    const purchaseInvoiceProduct = selectedProds.map((prod) => {
      const mrp = Number(prod.sale_price ?? prod.purchase_price ?? 0);
      const base = {
        product_id: prod.id || null,
        product_quantity: prod.selectedQty,
        product_purchase_price: mrp,
        product_sale_price: mrp,
        product_purchase_discount: prod.purchase_disc || 0,
      };
      if (prod.isNewProduct) {
        base.product_name = prod.name || "";
        base.isbn = prod.isbn || "";
      }
      return base;
    });

    const totalAmount = totalDiscountPaidDue.total;
    const totalProductDiscount = calculateTotalProductDiscount();
    const billDiscount = totalDiscountPaidDue.discount || 0;
    const paidAmount = values.paid_amount || 0;
    const subtotalAfterDiscounts = totalAmount - totalProductDiscount - billDiscount;
    const roundOff = isRoundOffEnabled ? roundOffAmount : 0;
    const finalTotal = subtotalAfterDiscounts + roundOff;
    const dueAmount = finalTotal - paidAmount;

    try {
      const valueData = {
        date: values.date || date,
        paid_amount: paidAmount,
        discount: billDiscount,
        supplier_id: values.supplier_id || supplier,
        supplier_memo_no: values.supplier_memo_no,
        billDiscount: values.billDiscount || 0,
        round_off_enabled: isRoundOffEnabled,
        round_off_amount: roundOff,
        total_amount: finalTotal,
        total_product_discount: totalProductDiscount,
        due_amount: dueAmount,
        purchase_order_id: purchaseOrderId || null,
        sales_order_id: salesOrderId || null,
        purchaseInvoiceProduct,
      };

      const resp = isEditMode
        ? await dispatch(updatePurchase(editId, valueData))
        : await dispatch(addPurchase(valueData));

      if (resp.message === "success") {
        const invoiceId = resp.createdInvoiceId;
        form.resetFields();
        setFormData({});
        setAfterDiscount(0);
        setDiscountAmount("");
        setAdditionalDiscount("");
        setSelectedProds([]);
        setTotalDiscountPaidDue({
          total: 0,
          discount: 0,
          afterDiscount: 0,
          paid: 0,
          due: 0,
          totalQty: 0,
        });
        setLoader(false);
        navigate(isEditMode ? `/purchase/${invoiceId}` : `/purchase/${invoiceId}`);
      } else {
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
      console.log(error.message);
      toast.error("Error while purchase");
    }
  };

  const onFormSubmit = async (values) => {
    return confirmMasterPriceSyncThen(selectedProds, () => runPurchaseSubmit(values));
  };

  const updateFormData = (e) => {
    const data = form.getFieldsValue();

    const total = data.purchaseInvoiceProduct?.reduce((acc, p) => {
      const { product_quantity = 0, product_purchase_price = 0, product_sale_price } = p;
      const unit = Number(product_sale_price ?? product_purchase_price ?? 0);
      acc += product_quantity * unit;
      return acc;
    }, 0);

    data.total = total;
    data.due = total - (data.paid_amount ?? 0) - (data.discount ?? 0);

    setFormData(data);
    if (data.discount) {
      setAfterDiscount(total - (data.discount ?? 0));
    }
    if (data.discount == 0) {
      setAfterDiscount(0);
    }
  };

  // Select Supplier Funciton
  const onChange = () => {
    updateFormData();
  };

  const onSelectChange = async (value) => {
    updateFormData();
    const { data } = await dispatch(loadSupplier(value));
    setSupplier(data);
  };

  const onSearch = (value) => { };

  // Products Handlers

  const [selectedProds, setSelectedProds] = useState([]);

  const prefillFromPurchaseOrder = (order) => {
    if (!order || !order.order_items || !allProducts?.length) return;
    const products = order.order_items
      .map((item) => {
        const product = allProducts.find((p) => p.id === item.product_id);
        if (!product) return null;
        const remainingQty = item.ordered_quantity - (item.received_quantity || 0);
        if (remainingQty <= 0) return null;
        const mrp =
          Number(product.sale_price) || Number(item.purchase_price) || 0;
        return {
          ...product,
          selectedQty: remainingQty,
          purchase_price: mrp,
          sale_price: mrp,
          purchase_disc: item.discount || 0,
          reference_list_price: getReferenceListPriceFromProduct(product),
        };
      })
      .filter(Boolean)
      .map((p, index) => ({ ...p, key: index }));
    const formProducts = products.map((p) => ({
      product_id: p.id,
      product_quantity: p.selectedQty || 1,
      product_purchase_price: p.sale_price ?? p.purchase_price ?? 0,
      product_sale_price: p.sale_price ?? p.purchase_price ?? 0,
      product_purchase_disc: p.purchase_disc || 0,
    }));
    setSelectedProds(products);
    if (formProducts.length > 0) {
      form.setFieldsValue({ purchaseInvoiceProduct: formProducts });
    }
    if (order.supplier_id) {
      setSupplier(order.supplier_id);
      form.setFieldsValue({ supplier_id: order.supplier_id });
    }
  };

  const prefillFromSalesOrder = (order) => {
    if (!order || !order.order_items || !allProducts?.length) return;
    const products = order.order_items
      .map((item) => {
        const product = allProducts.find((p) => p.id === item.product_id);
        if (!product) return null;
        const remainingQty = item.ordered_quantity - (item.fulfilled_quantity || 0);
        if (remainingQty <= 0) return null;
        const mrp =
          Number(product.sale_price) ||
          Number(item.sale_price) ||
          Number(product.purchase_price) ||
          0;
        return {
          ...product,
          selectedQty: remainingQty,
          purchase_price: mrp,
          sale_price: mrp,
          purchase_disc: 0,
          reference_list_price: getReferenceListPriceFromProduct(product),
        };
      })
      .filter(Boolean)
      .map((p, index) => ({ ...p, key: index }));
    const formProducts = products.map((p) => ({
      product_id: p.id,
      product_quantity: p.selectedQty || 1,
      product_purchase_price: p.sale_price ?? p.purchase_price ?? 0,
      product_sale_price: p.sale_price ?? p.purchase_price ?? 0,
      product_purchase_disc: p.purchase_disc || 0,
    }));
    setSelectedProds(products);
    if (formProducts.length > 0) {
      form.setFieldsValue({ purchaseInvoiceProduct: formProducts });
    }
  };

  // Handle order selection from URL params – clear product list first to avoid extra/duplicate row; wait for allProducts
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const poId = params.get("purchase_order_id");
    const soId = params.get("sales_order_id");

    if (poId) {
      setPurchaseOrderId(poId);
      setSalesOrderId(null);
      setSelectedProds([]);
      form.setFieldsValue({ purchaseInvoiceProduct: [] });
      if (allProducts?.length > 0) {
        dispatch(getPurchaseOrderById(poId)).then((result) => {
          if (result?.order) {
            prefillFromPurchaseOrder(result.order);
          }
        });
      }
      return;
    }

    if (soId) {
      setSalesOrderId(soId);
      setPurchaseOrderId(null);
      setSelectedProds([]);
      form.setFieldsValue({ purchaseInvoiceProduct: [] });
      if (allProducts?.length > 0) {
        dispatch(getSalesOrderById(soId)).then((result) => {
          if (result?.order) {
            prefillFromSalesOrder(result.order);
          }
        });
      }
      return;
    }
  }, [location.search, dispatch, allProducts?.length]);

  // Prefill form and products when editing an existing purchase invoice
  const [editPrefilled, setEditPrefilled] = useState(false);
  useEffect(() => {
    if (!isEditMode || !singlePurchaseInvoice || singlePurchaseInvoice.id !== Number(editId) || !allProducts?.length || editPrefilled) return;
    const invoice = singlePurchaseInvoice;
    const products = (invoice.purchaseInvoiceProduct || [])
      .map((item) => {
        const product = allProducts.find((p) => p.id === (item.product_id || item.product?.id));
        if (!product) return null;
        const mrp = Number(
          item.product_sale_price ??
            item.product_purchase_price ??
            product.sale_price ??
            0
        );
        return {
          ...product,
          key: item.id ?? Math.random(),
          selectedQty: item.product_quantity || 1,
          purchase_price: mrp,
          purchase_disc: item.product_purchase_discount ?? 0,
          sale_price: mrp,
          reference_list_price: getReferenceListPriceFromProduct(product),
        };
      })
      .filter(Boolean)
      .map((p, index) => ({ ...p, key: index }));
    const formProducts = products.map((p) => ({
      product_id: p.id,
      product_quantity: p.selectedQty || 1,
      product_purchase_price: p.sale_price ?? p.purchase_price ?? 0,
      product_sale_price: p.sale_price ?? p.purchase_price ?? 0,
      product_purchase_disc: p.purchase_disc || 0,
    }));
    setSelectedProds(products);
    const additionalDiscountValue = Number(invoice.discount) || 0;
    const grossTotal = products.reduce((sum, p) => {
      const price = Number(p.sale_price ?? p.purchase_price ?? 0);
      return sum + price * (Number(p.selectedQty) || 0);
    }, 0);
    const productDiscountTotal = products.reduce((sum, p) => {
      const disc = Number(p.purchase_disc) || 0;
      if (disc <= 0) return sum;
      const productPrice = Number(p.sale_price ?? p.purchase_price ?? 0) * (Number(p.selectedQty) || 0);
      return sum + productPrice * (disc / 100);
    }, 0);
    const afterProductDiscount = grossTotal - productDiscountTotal;
    const afterAdditionalDiscount = afterProductDiscount - additionalDiscountValue;

    form.setFieldsValue({
      supplier_id: invoice.supplier_id,
      date: invoice.date ? moment(invoice.date) : moment(),
      paid_amount: invoice.paid_amount ?? 0,
      supplier_memo_no: invoice.supplier_memo_no || undefined,
      purchaseInvoiceProduct: formProducts,
    });
    setSupplier(invoice.supplier_id);
    setDate(invoice.date ? moment(invoice.date) : moment());

    // Prefill Additional Discount amount/% inputs from invoice.discount
    if (additionalDiscountValue > 0) {
      setDiscountAmount(additionalDiscountValue);
      if (afterProductDiscount > 0) {
        const discountPercent = (additionalDiscountValue / afterProductDiscount) * 100;
        setAdditionalDiscount(Number(discountPercent.toFixed(2)));
      } else {
        setAdditionalDiscount("");
      }
    } else {
      setDiscountAmount("");
      setAdditionalDiscount("");
    }

    setTotalDiscountPaidDue((prev) => ({
      ...prev,
      total: grossTotal,
      discount: additionalDiscountValue,
      paid: Number(invoice.paid_amount) || 0,
      due: Number(invoice.due_amount) || afterAdditionalDiscount - (Number(invoice.paid_amount) || 0),
      afterDiscount: afterAdditionalDiscount,
      totalQty: products.reduce((sum, p) => sum + (Number(p.selectedQty) || 0), 0),
    }));
    setRoundOffAmount(Number(invoice.round_off_amount) || 0);
    setIsRoundOffEnabled(Boolean(invoice.round_off_enabled));
    setEditPrefilled(true);
  }, [isEditMode, editId, singlePurchaseInvoice, allProducts, form, editPrefilled]);

  const handleSelectedProds = (prodId, key) => {
    const foundProd = allProducts.find((item) => item.id === prodId);
    if (!foundProd) return;
    
    const billDiscForItem =
      discountType === "bill" && billDiscountFromForm != null && !Number.isNaN(Number(billDiscountFromForm))
        ? Number(billDiscountFromForm)
        : 0;
    const mrp = Number(foundProd.sale_price) || 0;
    const productWithPrice = {
      ...foundProd,
      sale_price: mrp,
      purchase_price: mrp,
      selectedQty: 1,
      purchase_disc: billDiscForItem,
      key: key,
      reference_list_price: getReferenceListPriceFromProduct(foundProd),
    };
    
    setSelectedProds((prev) => {
      // Find if this key already exists and update it, otherwise add new
      const existingIndex = prev.findIndex(prod => prod.key === key);
      if (existingIndex !== -1) {
        const updated = [...prev];
        updated[existingIndex] = productWithPrice;
        return updated;
      } else {
        return [...prev, productWithPrice];
      }
    });
    
    totalDiscountPaidDue.fixDiscountAmt = totalDiscountPaidDue.total - (totalDiscountPaidDue.total * discount / 100);
  };

  const handleSelectedProdsQty = (key, qty) => {
    setSelectedProds((prev) => 
      prev.map((prod) => 
        prod.key === key ? { ...prod, selectedQty: qty } : prod
      )
    );
  };

  const handleSelectedProdsPurchaseDisc = (key, purchaseDisc) => {
    setSelectedProds((prev) => 
      prev.map((prod) => 
        prod.key === key ? { ...prod, purchase_disc: purchaseDisc } : prod
      )
    );
    console.log("discount Handle", selectedProds);
  };

  /** List / MRP on purchase line; keeps purchase_price in sync for API (hidden from UI). */
  const handleSelectedProdsListPrice = (key, listPrice, formFieldIndex) => {
    const n = listPrice == null || listPrice === "" ? 0 : Number(listPrice);
    const safe = Number.isFinite(n) ? n : 0;
    setSelectedProds((prev) =>
      prev.map((prod) =>
        prod.key === key ? { ...prod, sale_price: safe, purchase_price: safe } : prod
      )
    );
    if (formFieldIndex !== undefined && form) {
      form.setFieldValue(
        ["purchaseInvoiceProduct", formFieldIndex, "product_purchase_price"],
        safe
      );
    }
  };

  const handleDeleteProd = (key) => {
    setSelectedProds((prev) => prev.filter((prod) => prod.key !== key));
  };

  const applyFlatDiscountToAll = (value) => {
    setGlobalDiscountValue(value);
    const normalizedValue =
      value === "" || value === null || Number.isNaN(Number(value))
        ? 0
        : Number(value);

    if (normalizedValue < 0 || normalizedValue > 100) {
      return;
    }

    setSelectedProds((prev) =>
      prev.map((prod) => ({
        ...prod,
        purchase_disc: normalizedValue,
      }))
    );
  };

  const applyQuantityToAll = (value) => {
    setGlobalQuantityValue(value);
    const normalizedValue =
      value === "" || value === null || Number.isNaN(Number(value))
        ? ""
        : Number(value);

    if (normalizedValue === "" || normalizedValue < 0) {
      return;
    }

    setSelectedProds((prev) =>
      prev.map((prod) => ({
        ...prod,
        selectedQty: normalizedValue,
      }))
    );
  };

  // When user enters ISBN and presses Enter but product not in DB - show row with ISBN + Product Name *
  const handleAddNewProductByISBN = (isbn, key) => {
    if (!isbn || !isbn.trim()) return;
    setSelectedProds((prev) => {
      const existingIndex = prev.findIndex(prod => prod.isbn === isbn.trim() && prod.isNewProduct);
      if (existingIndex !== -1) {
        const updated = [...prev];
        updated[existingIndex] = {
          ...updated[existingIndex],
          selectedQty: (updated[existingIndex].selectedQty || 1) + 1
        };
        return updated;
      }
      const billDiscForItem =
        discountType === "bill" && billDiscountFromForm != null && !Number.isNaN(Number(billDiscountFromForm))
          ? Number(billDiscountFromForm)
          : 0;
      const newProduct = {
        isbn: isbn.trim(),
        name: "",
        author: "",
        sale_price: 0,
        purchase_price: 0,
        selectedQty: 1,
        purchase_disc: billDiscForItem,
        key: key,
        isNewProduct: true,
        product_currency: allCurrency?.[0] || null,
        book_publisher: null,
      };
      return [...prev, newProduct];
    });
  };

  const handleUpdateNewProductField = (key, field, value) => {
    setSelectedProds((prev) =>
      prev.map((prod) => {
        if (prod.key !== key) return prod;
        const next = { ...prod, [field]: value };
        if (field === "book_publisher" && value && value.id) {
          next.book_publisher_id = value.id;
        }
        return next;
      })
    );
  };

  const handleOpenAddPublisher = (productKey, initialName = "") => {
    setPublisherProductKey(productKey);
    setPublisherInitialName(initialName);
    setPublisherModalVisible(true);
  };

  const handlePublisherAdded = (createdPublisher) => {
    if (createdPublisher && publisherProductKey != null) {
      setSelectedProds((prev) =>
        prev.map((p) =>
          p.key === publisherProductKey
            ? { ...p, book_publisher: createdPublisher, book_publisher_id: createdPublisher.id }
            : p
        )
      );
      toast.success("Publisher added and selected.");
    }
    setPublisherModalVisible(false);
    setPublisherInitialName("");
    setPublisherProductKey(null);
  };

  const handleDiscount = (rawDiscountAmount) => {
    // Treat empty / null / undefined as 0 so totals still calculate correctly
    const discountValue =
      rawDiscountAmount === "" || rawDiscountAmount === null || rawDiscountAmount === undefined
        ? 0
        : Number(rawDiscountAmount) || 0;
    const subtotalAfterProductDiscounts = totalDiscountPaidDue.total - calculateTotalProductDiscount();
    const afterDiscount = subtotalAfterProductDiscounts - discountValue;
    let dueAmount = afterDiscount;
    if (totalDiscountPaidDue.paid > 0) {
      dueAmount = dueAmount - totalDiscountPaidDue.paid;
    }
    setTotalDiscountPaidDue((prev) => ({
      ...prev,
      discount: discountValue,
      due: dueAmount,
      afterDiscount,
    }));
    setDiscountAmount(
      rawDiscountAmount === "" || rawDiscountAmount === null || rawDiscountAmount === undefined
        ? ""
        : discountValue
    );
    if (!discountValue) {
      setAdditionalDiscount("");
    } else if (subtotalAfterProductDiscounts > 0) {
      // Calculate and show percentage when amount is entered
      const discountPercent = (discountValue / subtotalAfterProductDiscounts) * 100;
      setAdditionalDiscount(Number(discountPercent.toFixed(2)));
    }
  };

  const handlePaid = (paidAmount) => {
    const dueAmount = totalDiscountPaidDue.afterDiscount - paidAmount;
    setTotalDiscountPaidDue((prev) => ({
      ...prev,
      paid: paidAmount,
      due: dueAmount,
    }));
  };

  /** Keep form line `product_purchase_price` aligned with List/MRP in state (column hidden in UI). */
  useEffect(() => {
    const rows = form.getFieldValue("purchaseInvoiceProduct");
    if (!Array.isArray(rows) || rows.length === 0 || selectedProds.length === 0) return;
    let changed = false;
    const next = rows.map((row, idx) => {
      const sp = selectedProds[idx];
      if (!sp) return row;
      const mrp = Number(sp.sale_price ?? sp.purchase_price ?? 0);
      if (Number(row?.product_purchase_price) === mrp) return row;
      changed = true;
      return { ...row, product_purchase_price: mrp };
    });
    if (changed) {
      form.setFieldsValue({ purchaseInvoiceProduct: next });
    }
  }, [selectedProds, form]);

  useEffect(() => {
    if (selectedProds.length > 0) {
      let total = 0;
      let afterDiscount = 0;
      let due = 0;
      let totalQty = 0;

      selectedProds.forEach((prod) => {
        const price = prod.sale_price ?? prod.purchase_price ?? 0;
        const conversion = prod.product_currency?.conversion ?? 1;
        total += price * (prod.selectedQty ?? 0) * conversion;
        totalQty += Number(prod.selectedQty) || 0;
      });

      // Calculate after product-level discounts and bill discount
      const totalProductDiscount = calculateTotalProductDiscount();
      const subtotalAfterProductDiscounts = total - totalProductDiscount;

      // When "Bill Discount" is selected, use form value (billDiscountFromForm) and convert % to amount
      const billDiscountPercent =
        discountType === "bill" && billDiscountFromForm != null && !Number.isNaN(Number(billDiscountFromForm))
          ? Number(billDiscountFromForm)
          : null;
      const billDiscountAmount =
        billDiscountPercent != null && billDiscountPercent > 0
          ? Math.round((subtotalAfterProductDiscounts * billDiscountPercent) / 100 * 100) / 100
          : discountType === "bill"
            ? 0
            : totalDiscountPaidDue.discount;

      if (billDiscountAmount > 0) {
        afterDiscount = subtotalAfterProductDiscounts - billDiscountAmount;
      } else {
        afterDiscount = subtotalAfterProductDiscounts;
      }

      if (totalDiscountPaidDue.paid > 0) {
        due = afterDiscount - totalDiscountPaidDue.paid;
      } else {
        due = afterDiscount;
      }

      setTotalDiscountPaidDue((prev) => ({
        ...prev,
        total,
        totalQty,
        discount: discountType === "bill"
          ? (billDiscountPercent != null && billDiscountPercent > 0
              ? Math.round((subtotalAfterProductDiscounts * billDiscountPercent) / 100 * 100) / 100
              : 0)
          : prev.discount,
        afterDiscount,
        due,
      }));
    } else {
      setTotalDiscountPaidDue((prev) => ({
        ...prev,
        totalQty: 0,
      }));
    }
  }, [selectedProds, totalDiscountPaidDue.paid, totalDiscountPaidDue.discount, discountType, billDiscountFromForm]);

  const handleDiscountTypeChange = (value) => {
    setDiscountType(value);
    if (value === "item") {
      setTotalDiscountPaidDue((prev) => ({ ...prev, discount: 0 }));
      setDiscountAmount("");
      setAdditionalDiscount("");
      form.setFieldsValue({ billDiscount: undefined });
      setDiscount(0);
    }
  };

  // Calculate total discount amount from individual product discounts
  const calculateTotalProductDiscount = () => {
    let totalProductDiscount = 0;
    selectedProds.forEach((prod) => {
      if (prod.purchase_disc > 0) {
        const productPrice = (prod.sale_price || prod.purchase_price) * prod.selectedQty;
        const currencyConversion = prod.product_currency?.conversion || 1;
        const productDiscountAmount = (productPrice * currencyConversion) * (prod.purchase_disc / 100);
        totalProductDiscount += productDiscountAmount;
      }
    });
    return totalProductDiscount;
  };

  // Calculate round-off amount
  const calculateRoundOff = (amount) => {
    const rounded = Math.round(amount);
    return rounded - amount;
  };

  // Handle round-off checkbox change
  const handleRoundOffChange = (e) => {
    const checked = e.target.checked;
    setIsRoundOffEnabled(checked);

    if (checked) {
      // Auto-calculate round off amount
      const subtotalAfterProductDiscounts = totalDiscountPaidDue.total - calculateTotalProductDiscount();
      const afterAdditionalDiscount = subtotalAfterProductDiscounts - totalDiscountPaidDue.discount;
      const roundedTotal = Math.round(afterAdditionalDiscount);
      const roundOff = roundedTotal - afterAdditionalDiscount;
      // Round to 2 decimal places
      const roundedRoundOff = Math.round(roundOff * 100) / 100;
      setRoundOffAmount(roundedRoundOff);
    } else {
      setRoundOffAmount(0);
    }
  };

  // Handle manual round-off amount change
  const handleRoundOffAmountChange = (value) => {
    setRoundOffAmount(value || 0);
  };

  // Handle extracted data from bill upload
  const handleBillDataExtracted = async (data) => {
    console.log('=== PARENT COMPONENT DEBUGGING ===');
    console.log('Extracted data received:', data);
    console.log('Existing supplier:', data.existingSupplier);
    console.log('New suppliers:', data.newSuppliers);
    console.log('Existing products:', data.existingProducts);
    console.log('New products:', data.newProducts);
    console.log('=== END PARENT DEBUGGING ===');

    setExtractedData(data);
    setShowBillUpload(false);

    try {
      // Auto-populate form with extracted data
      if (data.existingSupplier) {
        // Use existing supplier
        console.log('Setting existing supplier:', data.existingSupplier);
        setSupplier(data.existingSupplier.id);
        form.setFieldsValue({ supplier_id: data.existingSupplier.id });
      } else if (data.newSuppliers && data.newSuppliers.length > 0) {
        // Show message that supplier needs to be added first
        console.log('New supplier needs to be added first:', data.newSuppliers);
        toast.warning('Please add the supplier first before using the data.');
        return;
      } else {
        console.log('No supplier data available');
        toast.warning('No supplier information found in the extracted data.');
      }

      // Set bill date
      if (data.billDate) {
        const billDate = moment(data.billDate, 'YYYY-MM-DD');
        console.log('Setting bill date:', billDate.format('YYYY-MM-DD'));
        setDate(billDate);
        form.setFieldsValue({ date: billDate });
      }

      // Set bill number
      if (data.billNumber) {
        console.log('Setting bill number:', data.billNumber);
        form.setFieldsValue({ supplier_memo_no: data.billNumber });
      }

      // Process products - only existing products since new ones are already added to database
      let processedProducts = [];

      // Add existing products (includes newly created ones)
      if (data.existingProducts && data.existingProducts.length > 0) {
        console.log('Processing existing products:', data.existingProducts);
        processedProducts = data.existingProducts.map((product, idx) => {
          const mrp =
            Number(product.extractedPrice) ||
            Number(product.sale_price) ||
            0;
          return {
            ...product,
            selectedQty: product.extractedQuantity || 1,
            purchase_price: mrp,
            sale_price: mrp,
            purchase_disc: product.extractedDiscount || 0,
            key: product.key ?? idx,
            reference_list_price: getReferenceListPriceFromProduct(product),
          };
        });
      } else if (data.newProducts && data.newProducts.length > 0) {
        console.log('New products need to be added first:', data.newProducts);
        toast.warning('Please add the products first before using the data.');
        return;
      } else {
        console.log('No product data available');
        toast.warning('No product information found in the extracted data.');
      }

      console.log('Final processed products:', processedProducts);
      // Assign stable keys if any product is missing a key (prevents undefined keys)
      processedProducts = processedProducts.map((p, i) => ({
        ...p,
        key: p.key != null ? p.key : i,
      }));

      setSelectedProds(processedProducts);

      // Refresh products list to ensure all products are available for selection
      dispatch(loadProduct({ page: 1, limit: 10000 }));

      // Pre-populate form fields for each product to make them visible
      if (processedProducts.length > 0) {
        const formProducts = processedProducts.map((product, index) => ({
          product_id: product.id,
          product_quantity: product.selectedQty || 1,
          product_purchase_price: product.sale_price ?? product.purchase_price ?? 0,
          product_sale_price: product.sale_price ?? product.purchase_price ?? 0,
          product_purchase_disc: product.purchase_disc || 0
        }));

        form.setFieldsValue({
          purchaseInvoiceProduct: formProducts
        });
      }

      toast.success('Data populated successfully! Review and save the purchase.');
    } catch (error) {
      console.error('Error processing extracted data:', error);
      toast.error('Error processing extracted data');
    }
  };

  // Handle purchase confirmation with new items creation
  const handlePurchaseConfirmation = async (confirmationData) => {
    setLoader(true);

    try {
      let finalSupplierId = supplier;

      // Create new supplier if needed and confirmed
      if (confirmationData.confirmNewSupplier && confirmationData.newSuppliers && confirmationData.newSuppliers.length > 0) {
        const newSupplier = confirmationData.newSuppliers[0];
        const supplierResponse = await axios.post('/api/supplier', {
          name: newSupplier.name,
          phone: newSupplier.phone || '',
          address: newSupplier.address || ''
        });
        finalSupplierId = supplierResponse.data.id;
        setSupplier(finalSupplierId);
        form.setFieldsValue({ supplier_id: finalSupplierId });
      }

      // Create new publishers and currencies first
      const publisherMap = new Map();
      const currencyMap = new Map();

      // Create new publishers
      if (extractedData.newPublishers && extractedData.newPublishers.length > 0) {
        for (const publisher of extractedData.newPublishers) {
          try {
            const publisherResponse = await axios.post('/api/bookPublisher', {
              name: publisher.name
            });
            publisherMap.set(publisher.name, publisherResponse.data.id);
          } catch (error) {
            console.error('Error creating publisher:', error);
          }
        }
      }

      // Create new currencies
      if (extractedData.newCurrencies && extractedData.newCurrencies.length > 0) {
        for (const currency of extractedData.newCurrencies) {
          try {
            const currencyResponse = await axios.post('/api/productCurrency', {
              name: currency.name,
              symbol: currency.symbol || currency.name
            });
            currencyMap.set(currency.name, currencyResponse.data.id);
          } catch (error) {
            console.error('Error creating currency:', error);
          }
        }
      }

      // Create new products if selected
      const updatedProducts = [...selectedProds];
      if (confirmationData.newProducts && confirmationData.newProducts.length > 0) {
        for (const newProduct of confirmationData.newProducts) {
          // Get publisher ID (existing or newly created)
          let publisherId = newProduct.publisherId;
          if (!publisherId && newProduct.publisher) {
            publisherId = publisherMap.get(newProduct.publisher);
          }

          // Get currency ID (existing or newly created)
          let currencyId = newProduct.currencyId;
          if (!currencyId && newProduct.currency) {
            currencyId = currencyMap.get(newProduct.currency);
          }

          const productResponse = await axios.post('/api/product', {
            isbn: newProduct.isbn,
            name: newProduct.title,
            author: newProduct.author,
            book_publisher_id: publisherId,
            product_currency_id: currencyId,
            purchase_price: newProduct.price || 0,
            sale_price: newProduct.price || 0,
            quantity: 0,
            unit_type: 'copy',
            unit_measurement: 1,
            product_category_id: 1, // Default category
            reorder_quantity: 1
          });

          // Replace the temporary product with the real one
          const tempIndex = updatedProducts.findIndex(p => p.isNew && p.isbn === newProduct.isbn);
          if (tempIndex !== -1) {
            const created = productResponse.data;
            const mrp = Number(newProduct.price) || 0;
            updatedProducts[tempIndex] = {
              ...created,
              selectedQty: newProduct.quantity || 1,
              purchase_price: mrp,
              sale_price: mrp,
              purchase_disc: newProduct.discount || 0,
              isNew: false,
              reference_list_price: getReferenceListPriceFromProduct(created),
            };
          }
        }
      }

      // Remove unselected new products
      const finalProducts = updatedProducts.filter(product => {
        if (product.isNew) {
          // Keep only if this product was selected
          return confirmationData.newProducts.some(np => np.isbn === product.isbn);
        }
        return true; // Keep all existing products
      });

      setSelectedProds(finalProducts);

      // Now submit the purchase with the final data
      const purchaseInvoiceProduct = finalProducts.map((product) => {
        const mrp = Number(product.sale_price ?? product.purchase_price ?? 0);
        return {
          product_id: product.id,
          product_quantity: product.selectedQty,
          product_purchase_price: mrp,
          product_sale_price: mrp,
          product_purchase_discount: product.purchase_disc || 0,
        };
      });

      // Calculate totals for submission
      const totalAmount = totalDiscountPaidDue.total;
      const totalProductDiscount = calculateTotalProductDiscount();
      const billDiscount = totalDiscountPaidDue.discount;
      const paidAmount = totalDiscountPaidDue.paid;
      const subtotalAfterDiscounts = totalAmount - totalProductDiscount - billDiscount;
      const roundOff = isRoundOffEnabled ? roundOffAmount : 0;
      const finalTotal = subtotalAfterDiscounts + roundOff;
      const dueAmount = finalTotal - paidAmount;

      const values = {
        date: date,
        paid_amount: paidAmount,
        discount: billDiscount,
        supplier_id: finalSupplierId,
        supplier_memo_no: form.getFieldValue('supplier_memo_no'),
        round_off_enabled: isRoundOffEnabled,
        round_off_amount: roundOff,
        total_amount: finalTotal,
        total_product_discount: totalProductDiscount,
        due_amount: dueAmount,
        purchaseInvoiceProduct,
      };

      await confirmMasterPriceSyncThen(finalProducts, async () => {
        const resp = await axios.post('/api/purchaseInvoice', values);

        if (resp.data.success) {
          setLoader(false);
          toast.success('Purchase bill saved successfully!');
          setShowConfirmation(false);
          setExtractedData(null);
          form.resetFields();
          setSelectedProds([]);
          setSupplier(null);
          setDate(moment());
          setDiscountAmount("");
          setAdditionalDiscount("");
          setTotalDiscountPaidDue({
            total: 0,
            discount: 0,
            afterDiscount: 0,
            paid: 0,
            due: 0,
            totalQty: 0,
          });
          navigate('/admin/dashboard');
        } else {
          setLoader(false);
        }
      });
    } catch (error) {
      setLoader(false);
      console.error('Error saving purchase:', error);
      toast.error('Error saving purchase bill');
    }
  };

  // Modified form submit to show confirmation
  const onFormSubmitWithConfirmation = async () => {
    const purchaseData = {
      supplier: extractedData?.existingSupplier || extractedData?.supplier,
      date: date,
      supplier_memo_no: form.getFieldValue('supplier_memo_no'),
      selectedProducts: selectedProds,
      discount: totalDiscountPaidDue.discount,
      paid_amount: totalDiscountPaidDue.paid
    };

    setConfirmationData(purchaseData);
    setShowConfirmation(true);
  };


  {/*
  const handlePercentageDiscount = (discountPercent) => {
    const additionalDiscountAmount = (totalDiscountPaidDue.total * discountPercent) / 100;
    setAdditionalDiscount(discountPercent);
    // handleDiscount(additionalDiscountAmount);
	const discountAmount = totalDiscountPaidDue.total - additionalDiscountAmount;
  setAdditionalDiscount(discountPercent);
  setDiscountAmount(discountAmount);
  handleDiscount(discountAmount);

  };
*/}

  const handlePercentageDiscount = (discountPercent) => {
    // Treat empty / null / undefined as 0 so totals still calculate correctly
    if (discountPercent === "" || discountPercent === null || discountPercent === undefined) {
      setAdditionalDiscount("");
      handleDiscount("");
      return;
    }
    const percentValue = Number(discountPercent) || 0;
    let additionalDiscountAmount = 0;
    if (percentValue > 0) {
      const subtotalAfterProductDiscounts = totalDiscountPaidDue.total - calculateTotalProductDiscount();
      // Round to 2 decimal places
      additionalDiscountAmount = Math.round((subtotalAfterProductDiscounts * percentValue) / 100 * 100) / 100;
    }
    setAdditionalDiscount(percentValue || "");
    handleDiscount(additionalDiscountAmount);
  };


  return (
    <Card>
      <Form
        form={form}
        className="m-lg-4"
        name="dynamic_form_nest_item"
        onFinish={onFormSubmit}
        onFinishFailed={() => {
          setLoader(false);
        }}
        // onChange={onChange}
        layout="vertical"
        size="medium"
        autoComplete="off"
      >
        <Row gutter={[24, 24]}>
          <Col span={24}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Title level={4}>
                Add Purchase Bill
              </Title>
              <Space>
                <Button
                  type="primary"
                  icon={<RobotOutlined />}
                  onClick={() => setShowBillUpload(true)}
                  style={{ backgroundColor: '#52c41a', borderColor: '#52c41a' }}
                >
                  Bill Upload
                </Button>
              </Space>
            </div>
          </Col>
          <Col span={24} lg={24}>
            {/* Desktop Layout */}
            <div className="d-none d-lg-flex justify-content-between mb-1">
              {/* Invoice Number removed — auto-generated by backend document series */}
              <Form.Item
                label="Supplier "
                name="supplier_id"
                style={{ maxWidth: "350px" }}
                rules={[
                  {
                    required: true,
                    message: "Please Select a supplier!",
                  },
                ]}
              >
                <Select
                  loading={!allSuppliers}
                  showSearch
                  placeholder="Select a supplier "
                  optionFilterProp="children"
                  onChange={(id) => {
                    if (id === '__add_supplier__') {
                      form.setFieldsValue({ supplier_id: undefined });
                      setSupplier(null);
                      setAddSupplierModalVisible(true);
                      return;
                    }
                    setSupplier(id);
                    setSupplierSearchValue('');
                  }}
                  onSearch={(value) => setSupplierSearchValue(value || '')}
                  filterOption={(input, option) =>
                    option?.value === '__add_supplier__' ? true : option?.children?.toLowerCase().includes(input?.toLowerCase())
                  }
                >
                  {/* Show new supplier option if extracted data has new supplier */}
                  {extractedData && extractedData.newSuppliers && extractedData.newSuppliers.length > 0 && (
                    <Option key="new" value="new" style={{ backgroundColor: '#f6ffed', border: '1px solid #b7eb8f' }}>
                      🆕 {extractedData.newSuppliers[0].name} (New - will be created)
                    </Option>
                  )}
                  {allSuppliers &&
                    allSuppliers.map((sup) => (
                      <Option key={sup.id} value={sup.id}>
                        {sup.name}
                      </Option>
                    ))}
                  <Option value="__add_supplier__" style={{ color: '#1890ff', fontWeight: 600, borderTop: '1px solid #f0f0f0' }}>
                    <PlusOutlined /> Add New Supplier{supplierSearchValue?.trim() ? `: "${supplierSearchValue.trim()}"` : ''}
                  </Option>
                </Select>
              </Form.Item>
              <Form.Item
                label="Bill Date"
                name="date"
                initialValue={date}
                rules={[
                  {
                    required: true,
                    message: "Please input Date!",
                  },
                ]}
              >
                <DatePicker
                  onChange={(value) => setDate(value ? value._d : moment()._d)}
                  format={"YYYY-MM-DD"}
                  style={{ marginBottom: "10px", paddingTop: "10px" }}
                  className="date-picker"
                />
              </Form.Item>

              <Form.Item name="supplier_memo_no" label="Supplier Bill No.">
                <Input placeholder="Bill No. " onChange={updateFormData} />
              </Form.Item>

              <Form.Item label="Set Discount">
                <Radio.Group
                  value={discountType}
                  onChange={(e) => handleDiscountTypeChange(e.target.value)} >
                  <Radio value="bill">Bill Discount</Radio>
                  <Radio value="item">Item Wise Discount</Radio>
                </Radio.Group>
                <br />
                <br />
                {discountType === "bill" && (
                  <Form.Item
                    name="billDiscount"
                    rules={[
                      {
                        required: true,
                        message: "Please input bill discount!",
                      },
                      {
                        validator: (_, value) => {
                          const floatValue = parseFloat(value);
                          if (
                            isNaN(floatValue) ||
                            floatValue < 0 ||
                            floatValue > 100
                          ) {
                            return Promise.reject(
                              "Discount must be a number between 0 and 100"
                            );
                          }
                          const decimalPlaces = floatValue
                            .toString()
                            .split(".")[1];
                          if (decimalPlaces && decimalPlaces.length > 2) {
                            return Promise.reject(
                              "Discount can have maximum 2 decimal places"
                            );
                          }
                          return Promise.resolve();
                        },
                      },
                    ]}
                    visible={discountType === "bill"}
                  >
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <InputNumber
                        placeholder="Enter bill discount"
                        style={{ width: "85%" }}
                        onChange={(value) => setDiscount(value)}
                        disabled={discountType !== "bill"}
                      />
                      <h3 style={{ margin: "0 0 0 10px" }}>%</h3>
                    </div>
                  </Form.Item>
                )}
              </Form.Item>

              <Form.Item label="Apply To All Items">
                <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                  <InputNumber
                    placeholder="Flat discount %"
                    min={0}
                    max={100}
                    value={globalDiscountValue}
                    onChange={applyFlatDiscountToAll}
                    style={{ width: "100%", maxWidth: "180px" }}
                  />
                  <InputNumber
                    placeholder="Set quantity"
                    min={0}
                    value={globalQuantityValue}
                    onChange={applyQuantityToAll}
                    style={{ width: "100%", maxWidth: "180px" }}
                  />
                </div>
              </Form.Item>
            </div>

            {/* Mobile Layout */}
            <div className="d-lg-none">
              <Row gutter={[16, 16]}>
                <Col xs={24}>
                  <Form.Item
                    label="Supplier"
                    name="supplier_id"
                    rules={[
                      {
                        required: true,
                        message: "Please Select a supplier!",
                      },
                    ]}
                  >
                    <Select
                      loading={!allSuppliers}
                      showSearch
                      placeholder="Select a supplier"
                      optionFilterProp="children"
                      onChange={(id) => {
                        if (id === '__add_supplier__') {
                          form.setFieldsValue({ supplier_id: undefined });
                          setSupplier(null);
                          setAddSupplierModalVisible(true);
                          return;
                        }
                        setSupplier(id);
                        setSupplierSearchValue('');
                      }}
                      onSearch={(value) => setSupplierSearchValue(value || '')}
                      filterOption={(input, option) =>
                        option?.value === '__add_supplier__' ? true : option?.children?.toLowerCase().includes(input?.toLowerCase())
                      }
                      style={{ fontSize: '13px', width: '100%' }}
                      dropdownStyle={{ fontSize: '13px' }}
                    >
                      {extractedData && extractedData.newSuppliers && extractedData.newSuppliers.length > 0 && (
                        <Option key="new" value="new" style={{ backgroundColor: '#f6ffed', border: '1px solid #b7eb8f' }}>
                          🆕 {extractedData.newSuppliers[0].name} (New - will be created)
                        </Option>
                      )}
                      {allSuppliers &&
                        allSuppliers.map((sup) => (
                          <Option key={sup.id} value={sup.id}>
                            {sup.name}
                          </Option>
                        ))}
                      <Option value="__add_supplier__" style={{ color: '#1890ff', fontWeight: 600, borderTop: '1px solid #f0f0f0' }}>
                        <PlusOutlined /> Add New Supplier{supplierSearchValue?.trim() ? `: "${supplierSearchValue.trim()}"` : ''}
                      </Option>
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={12}>
                  <Form.Item
                    label="Bill Date"
                    name="date"
                    initialValue={date}
                    rules={[
                      {
                        required: true,
                        message: "Please input Date!",
                      },
                    ]}
                  >
                    <DatePicker
                      onChange={(value) => setDate(value ? value._d : moment()._d)}
                      format={"DD-MMM-YYYY"}
                      style={{ width: "100%", fontSize: '13px' }}
                      placeholder="Bill Date"
                    />
                  </Form.Item>
                </Col>

                <Col xs={12}>
                  <Form.Item name="supplier_memo_no" label="Bill No.">
                    <Input placeholder="Bill No." onChange={updateFormData} style={{ fontSize: '13px' }} />
                  </Form.Item>
                </Col>

                <Col xs={24}>
                  <Form.Item label="Discount Type">
                    <Radio.Group
                      value={discountType}
                      onChange={(e) => handleDiscountTypeChange(e.target.value)}
                      style={{ width: '100%' }}
                    >
                      <Radio value="bill">Bill Discount</Radio>
                      <Radio value="item">Item Wise</Radio>
                    </Radio.Group>
                  </Form.Item>
                  {discountType === "bill" && (
                    <Form.Item
                      name="billDiscount"
                      rules={[
                        {
                          required: true,
                          message: "Please input bill discount!",
                        },
                        {
                          validator: (_, value) => {
                            const floatValue = parseFloat(value);
                            if (
                              isNaN(floatValue) ||
                              floatValue < 0 ||
                              floatValue > 100
                            ) {
                              return Promise.reject(
                                "Discount must be a number between 0 and 100"
                              );
                            }
                            const decimalPlaces = floatValue
                              .toString()
                              .split(".")[1];
                            if (decimalPlaces && decimalPlaces.length > 2) {
                              return Promise.reject(
                                "Discount can have maximum 2 decimal places"
                              );
                            }
                            return Promise.resolve();
                          },
                        },
                      ]}
                    >
                      <InputNumber
                        placeholder="Enter bill discount"
                        style={{ width: "100%" }}
                        onChange={(value) => setDiscount(value)}
                        disabled={discountType !== "bill"}
                        addonAfter="%"
                      />
                    </Form.Item>
                  )}
                </Col>

                <Col xs={24}>
                  <Form.Item label="Apply To All Items">
                    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                      <InputNumber
                        placeholder="Flat discount %"
                        min={0}
                        max={100}
                        value={globalDiscountValue}
                        onChange={applyFlatDiscountToAll}
                        style={{ width: "100%", fontSize: '13px' }}
                      />
                      <InputNumber
                        placeholder="Set quantity"
                        min={0}
                        value={globalQuantityValue}
                        onChange={applyQuantityToAll}
                        style={{ width: "100%", fontSize: '13px' }}
                      />
                    </div>
                  </Form.Item>
                </Col>
              </Row>
            </div>

            <Products
              formData={formData}
              setData={setFormData}
              allProducts={allProducts}
              selectedProds={selectedProds}
              handleSelectedProds={handleSelectedProds}
              handleSelectedProdsQty={handleSelectedProdsQty}
              handleSelectedProdsListPrice={handleSelectedProdsListPrice}
              handleDeleteProd={handleDeleteProd}
              handleSelectedProdsPurchaseDisc={handleSelectedProdsPurchaseDisc}
              form={form}
              handleAddNewProductByISBN={handleAddNewProductByISBN}
              handleUpdateNewProductField={handleUpdateNewProductField}
              allCurrencies={allCurrency}
              allPublishers={allPublishers}
              onOpenAddPublisher={handleOpenAddPublisher}
            />
          </Col>
          <Col xs={24} lg={8}>
            <ul>
              {allCurrency && allCurrency.filter((cur, i) => selectedProds.indexOf(cur.symbol) && cur.symbol != '₹').map((cur) => (
                <li key={cur.id}>{cur.symbol + '1 = ₹' + cur.conversion}</li>
              ))}
            </ul>
          </Col>
          <Col xs={0} lg={8}></Col>
          <Col xs={24} lg={8}>
            <div
              style={{
                padding: "10px 20px",
                display: "flex",
                justifyContent: "space-between",
                border: "1px solid #ccc",
                fontSize: '14px'
              }}
            >
              <strong>Total Amt. : </strong>
              <strong>Rs. {totalDiscountPaidDue.total.toFixed(2)}</strong>
            </div>
            <div
              style={{
                padding: "10px 20px",
                display: "flex",
                justifyContent: "space-between",
                border: "1px solid #ccc",
                fontSize: '14px'
              }}
            >
              <strong>Total Discount Amt. : </strong>
              <strong>Rs.{calculateTotalProductDiscount().toFixed(2)} </strong>
            </div>
            <div
              style={{
                padding: "10px 20px",
                display: "flex",
                flexDirection: window.innerWidth < 992 ? "column" : "row",
                justifyContent: "space-between",
                alignItems: window.innerWidth < 992 ? "stretch" : "center",
                gap: window.innerWidth < 992 ? "10px" : "0",
                border: "1px solid #ccc",
                fontSize: "14px",
              }}
            >
              <div style={{ marginRight: window.innerWidth >= 992 ? "15px" : "0" }}>
                <strong>Additional Discount:</strong>
              </div>

              <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
                <InputNumber
                  type="number"
                  placeholder="Enter disc Amt"
                  addonBefore="Rs."
                  onChange={(value) => {
                    if (value === null || value === undefined || value === "") {
                      setDiscountAmount("");
                      setAdditionalDiscount("");
                      handleDiscount("");
                    } else {
                      setDiscountAmount(value);
                      handleDiscount(value);
                    }
                  }}
                  value={discountAmount === "" ? null : discountAmount}
                  style={{ width: window.innerWidth < 576 ? "100%" : "320px", minWidth: 160, flex: window.innerWidth < 576 ? "1" : "0" }}
                  precision={2}
                  step={0.01}
                />
                <InputNumber
                  type="number"
                  placeholder="Enter discount %"
                  addonAfter="%"
                  onChange={(value) => {
                    if (value === null || value === undefined || value === "") {
                      setAdditionalDiscount("");
                      setDiscountAmount("");
                      handleDiscount("");
                    } else {
                      handlePercentageDiscount(value);
                    }
                  }}
                  value={additionalDiscount === "" ? null : additionalDiscount}
                  style={{ width: window.innerWidth < 576 ? "100%" : "250px", minWidth: 140, flex: window.innerWidth < 576 ? "1" : "0" }}
                  precision={2}
                  step={0.01}
                />
              </div>
            </div>
            <div
              style={{
                padding: "10px 20px",
                display: "flex",
                justifyContent: "space-between",
                border: "1px solid #ccc",
                fontSize: '14px'
              }}
            >
              <strong>After Additional Discount : </strong>
              <strong>Rs. {(totalDiscountPaidDue.total - calculateTotalProductDiscount() - totalDiscountPaidDue.discount).toFixed(2)}</strong>
            </div>
            <div
              style={{
                padding: "10px 20px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                border: "1px solid #ccc",
                fontSize: "14px",
              }}
            >
              <div>
                <strong>Paid Amount: </strong>
              </div>
              <Form.Item
                name="paid_amount"
                style={{ maxWidth: "200px", marginBottom: 0, width: "100%" }}
                initialValue={0}
              >
                <InputNumber 
                  type="number" 
                  onChange={handlePaid} 
                  addonBefore="Rs." 
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </div>

            <div
              style={{
                padding: "10px 20px",
                display: "flex",
                justifyContent: "space-between",
                border: "1px solid #ccc",
                marginBottom: "10px",
                fontSize: '14px'
              }}
            >
              <strong>Due Amount: </strong>
              <strong>Rs.{((totalDiscountPaidDue.total - calculateTotalProductDiscount() - totalDiscountPaidDue.discount) - totalDiscountPaidDue.paid).toFixed(2)}</strong>
            </div>

            {/* Round Off Section */}
            <div
              style={{
                padding: "10px 20px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                border: "1px solid #ccc",
                marginBottom: "10px",
              }}
            >
              <Checkbox
                checked={isRoundOffEnabled}
                onChange={handleRoundOffChange}
              >
                <strong>Round Off</strong>
              </Checkbox>
              {isRoundOffEnabled && (
                <InputNumber
                  value={roundOffAmount}
                  onChange={handleRoundOffAmountChange}
                  addonBefore="Rs."
                  style={{ width: "150px" }}
                  step={0.01}
                  precision={2}
                />
              )}
            </div>

            {/* Final Amount After Round Off */}
            {isRoundOffEnabled && (
              <div
                style={{
                  padding: "10px 20px",
                  display: "flex",
                  justifyContent: "space-between",
                  border: "2px solid #1890ff",
                  marginBottom: "10px",
                  backgroundColor: "#e6f7ff",
                }}
              >
                <strong>Final Amount: </strong>
                <strong style={{ fontSize: "18px", color: "#1890ff" }}>
                  Rs.{(((totalDiscountPaidDue.total - calculateTotalProductDiscount() - totalDiscountPaidDue.discount) - totalDiscountPaidDue.paid) + roundOffAmount).toFixed(2)}
                </strong>
              </div>
            )}

            <div
              style={{
                padding: "10px 20px",
                display: "flex",
                justifyContent: "space-between",
                border: "1px solid #ccc",
                marginBottom: "10px",
                fontSize: "14px",
              }}
            >
              <strong>Total Qty: </strong>
              <strong>{totalDiscountPaidDue.totalQty ?? 0} Copies</strong>
            </div>

            <Form.Item style={{ marginTop: "15px" }}>
              <Button
                block
                type="primary"
                htmlType="submit"
                loading={loader}
                onClick={() => {
                  onClickLoading();
                  if (extractedData && (extractedData.newSuppliers?.length > 0 || extractedData.newProducts?.length > 0)) {
                    onFormSubmitWithConfirmation();
                  }
                  // Form will handle submission through onFinish
                }}
              >
                Save Purchase Bill
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>

      {/* Bill Upload Modal */}
      {showBillUpload && (
        <BillUpload
          onDataExtracted={handleBillDataExtracted}
          onClose={() => setShowBillUpload(false)}
        />
      )}

      {/* Purchase Confirmation Modal */}
      {showConfirmation && (
        <PurchaseConfirmation
          visible={showConfirmation}
          onConfirm={handlePurchaseConfirmation}
          onCancel={() => setShowConfirmation(false)}
          purchaseData={confirmationData}
          newSuppliers={extractedData?.newSuppliers || []}
          newProducts={extractedData?.newProducts || []}
          newPublishers={extractedData?.newPublishers || []}
          newCurrencies={extractedData?.newCurrencies || []}
          loading={loader}
        />
      )}

      {/* Add New Supplier Modal - from dropdown */}
      <Modal
        title="Add New Supplier"
        open={addSupplierModalVisible}
        onCancel={() => setAddSupplierModalVisible(false)}
        footer={null}
        destroyOnClose
        width={480}
      >
        <AddSup
          inModal
          prefilledName={supplierSearchValue?.trim() || ''}
          onSuccess={(newSupplier) => {
            if (newSupplier?.id) {
              dispatch(loadSuppliers({ page: 1, limit: 10000 }));
              setSupplier(newSupplier.id);
              form.setFieldsValue({ supplier_id: newSupplier.id });
            }
            setSupplierSearchValue('');
            setAddSupplierModalVisible(false);
          }}
          onCancel={() => {
            setAddSupplierModalVisible(false);
            setSupplierSearchValue('');
          }}
        />
      </Modal>

      {/* Add New Publisher Modal - from product row */}
      <Modal
        title="Add Publisher"
        open={publisherModalVisible}
        onCancel={() => {
          setPublisherModalVisible(false);
          setPublisherInitialName("");
          setPublisherProductKey(null);
        }}
        footer={null}
        destroyOnClose
        width={520}
      >
        <AddBookPublisher
          inModal
          prefillText={publisherInitialName}
          onSuccess={handlePublisherAdded}
          onCancel={() => {
            setPublisherModalVisible(false);
            setPublisherInitialName("");
            setPublisherProductKey(null);
          }}
        />
      </Modal>
    </Card>
  );
};

export default AddPurch;
